import React from "react";
import { Line, Pie, Doughnut, Bar } from "react-chartjs-2";
import moment from "moment";
import services from "./service";
import {
  Col,
  Row,
  Spin,
  Table,
  Card,
  notification,
  Tooltip,
  Icon,
  Tag,
} from "antd";

const TAG_COLOR = ["pink", "red", "orange", "green", "cyan", "blue", "purple"];

class SMPPUsageStatus extends React.Component {
  state = {
    loading: false,
    data: {
      summary: {
        total_transaction: 0,
        total_member: 0,
        total_country: {},
        total_income: 0,
        status_recevied: { success: 0, failed: 0, blackhole: 0 },
      },
      list: [],
      trend_sms: [],
    },
    total: 0,
    currentPage: 0,
    limit: 99,

    selectedRowKeys: [],
  };

  async componentDidMount() {
    this.setState({
      loading: true,
    });

    let IstartDate = moment().subtract(1, "M").format("YYYY-MM-DD");
    let IendDate = moment().format("YYYY-MM-DD");

    await this.fetchSummary(
      this.state.currentPage,
      this.state.limit,
      0,
      "",
      IstartDate,
      IendDate
    );
  }

  async componentDidUpdate(prevProps) {
    const { memberId, country, startDate, endDate } = this.props;
    if (
      memberId === prevProps.memberId &&
      country === prevProps.country &&
      startDate === prevProps.startDate &&
      endDate === prevProps.endDate
    ) {
      return;
    }

    this.setState({
      loading: true,
      currentPage: 1,
    });

    let IstartDate =
      startDate || moment().subtract(1, "M").format("YYYY-MM-DD");
    let IendDate = endDate || moment().format("YYYY-MM-DD");

    await this.fetchSummary(
      1,
      this.state.limit,
      memberId,
      country,
      IstartDate,
      IendDate
    );
  }

  fetchSummary = async (page, limit, memberID, country, startDate, endDate) => {
    const data = await services._getSummary(
      startDate,
      endDate,
      memberID,
      country,
      page,
      limit
    );

    if (typeof data === "string") {
      this.setState({
        loading: false,
      });
      notification.error({
        message: "Filter Error",
        description: data,
      });

      return;
    }

    this.setState(
      {
        data: data.data,
        total: data.total_rows,
        currentPage: data.page,
        limit: data.limit,
      },
      () => {
        this.setState({
          loading: false,
        });
      }
    );
  };

  safeDisplayFloat = (number) => {
    return (
      <span className="numeric-data">
        {Number(number || 0).toLocaleString("en-US", {
          maximumFractionDigits: 2,
          notation: "compact",
          compactDisplay: "short",
        })}
      </span>
    );
  };

  getRandomHexColor = () => {
    const hex = "ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      // Select a random character from the restricted hex string
      color += hex[Math.floor(Math.random() * hex.length)];
    }
    return color;
  };

  renderTransactionOverTime = () => {
    let labels = [];
    let row = [];

    if (this.state.selectedRowKeys.length > 0) {
      const selectedRow = this.state.data.list.filter((v) =>
        this.state.selectedRowKeys.includes(v.member_id)
      );

      for (const element of selectedRow) {
        const mapTotal = element.total_date;
        const date = Object.keys(mapTotal);

        for (const d of date) {
          if (!labels.includes(d)) {
            labels.push(d);
          }
        }

        for (const c of date) {
          const ind = labels.findIndex((v) => v === c);
          if (!row[ind]) {
            row[ind] = 0;
          }
          row[ind] += mapTotal[c];
        }
      }
    } else {
      if (this.state.data.trend_sms.length > 0) {
        labels = Object.keys(this.state.data.trend_sms);
        row = Object.values(this.state.data.trend_sms);

        for (let index = 0; index < this.state.data.trend_sms.length; index++) {
          const element = this.state.data.trend_sms[index];
          labels.push(element.key);
          row.push(element.value);
        }
      }
    }

    return (
      <div className="chart">
        <Line
          datasetIdKey="id"
          data={{
            labels,
            datasets: [
              {
                id: 1,
                label: "SMS",
                data: row,
                borderColor: "#4CAF00",
                backgroundColor: "#4CAF00",
                fill: true,
              },
            ],
          }}
        />
      </div>
    );
  };

  renderSuccessVsFailVsBlackhole = () => {
    let row = [];
    if (this.state.selectedRowKeys.length > 0) {
      const selectedRow = this.state.data.list.filter((v) =>
        this.state.selectedRowKeys.includes(v.member_id)
      );
      let failed = 0;
      let success = 0;
      let blackhole = 0;

      for (const element of selectedRow) {
        failed += element.total_failed;
        success += element.total_success;
        blackhole += element.total_blackhole;
      }

      row = [failed, success, blackhole];
    } else {
      if (this.state.data.summary.status_recevied) {
        const { success, failed, blackhole } =
          this.state.data.summary.status_recevied;

        row = [failed, success, blackhole];
      }
    }

    row = row.map((v) => v * 100);

    return (
      <div className="chart">
        <Pie
          data={{
            labels: ["Failure", "Success", "Blackhole"],
            datasets: [
              {
                data: row,
                backgroundColor: [
                  "#ff4d00ff",
                  "#6fff00ff",
                  "rgba(251, 255, 0, 1)",
                ],
                borderColor: "#001529",
                borderWidth: 1,
              },
            ],
          }}
        />
      </div>
    );
  };

  renderDistributeByCountry = () => {
    let labels = [];
    let row = [];
    let bgColour = [];

    if (this.state.selectedRowKeys.length > 0) {
      const selectedRow = this.state.data.list.filter((v) =>
        this.state.selectedRowKeys.includes(v.member_id)
      );

      for (const element of selectedRow) {
        const mapCountry = element.total_country;
        const country = Object.keys(mapCountry);
        for (const v of country) {
          if (!labels.includes(v)) {
            labels.push(v);
          }
        }

        for (const c of country) {
          const ind = labels.findIndex((v) => v === c);
          if (!row[ind]) {
            row[ind] = 0;
          }

          row[ind] += mapCountry[c];
        }
      }

      bgColour = labels.map(() => this.getRandomHexColor());
    } else {
      if (this.state.data.summary.total_country) {
        labels = Object.keys(this.state.data.summary.total_country);
        row = Object.values(this.state.data.summary.total_country).map(
          (i) => i * 100
        );
        bgColour = labels.map(() => this.getRandomHexColor());
      }
    }

    let data = {
      labels: labels,
      datasets: [
        {
          label: "Country",
          data: row,
          backgroundColor: bgColour,
          borderColor: "#001529",
          borderWidth: 1,
        },
      ],
    };

    let barDataSet = [];
    let list = [];
    if (this.state.selectedRowKeys.length > 0) {
      const selectedRow = this.state.data.list.filter((v) =>
        this.state.selectedRowKeys.includes(v.member_id)
      );
      list = selectedRow;
    } else {
      if (this.state.data.list.length > 0) {
        list = this.state.data.list;
      }
    }

    barDataSet = list.map((v) => {
      return {
        label: v.system_id,
        data: labels.map((c) => v.total_country[c] || 0),
        backgroundColor: this.getRandomHexColor(),
      };
    });

    return (
      <div className="chart">
        <Doughnut data={data} />
        <Bar
          data={{
            labels: labels,
            datasets: barDataSet,
          }}
          options={{
            indexAxis: "y",
            elements: {
              bar: {
                borderWidth: 2,
              },
            },
          }}
        />
      </div>
    );
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  onCloseTag = (memberId) => {
    const { selectedRowKeys } = this.state;
    this.setState({
      selectedRowKeys: selectedRowKeys.filter((id) => id !== memberId),
    });
  };

  renderSelectedMember = () => {
    const { selectedRowKeys, data } = this.state;
    if (selectedRowKeys.length === 0) {
      return;
    }

    return selectedRowKeys.map((id) => {
      const item = data.list.find((v) => v.member_id === id);
      const color = TAG_COLOR[Math.floor(Math.random() * TAG_COLOR.length)];
      return (
        <Tag
          className="filter-tag"
          closable
          color={color}
          onClose={() => this.onCloseTag(id)}
        >
          {item.system_id}
        </Tag>
      );
    });
  };

  renderMemberTable = () => {
    const { selectedRowKeys } = this.state;
    const { list } = this.state.data;
    const column = [
      {
        title: "SystemID",
        align: "center",
        render: (record) => {
          return (
            <span>
              {record.system_id}
              {String(record.binding_to).length > 0 ? (
                <Tooltip title={record.binding_to}>
                  <Icon
                    type="check-circle-o"
                    style={{
                      color: "inherit",
                      backgroundColor: "inherit",
                      borderColor: "inherit",
                    }}
                  />
                </Tooltip>
              ) : null}
            </span>
          );
        },
      },
      {
        title: "MemberID",
        dataIndex: "member_id",
        align: "center",
      },
      {
        title: "Expense",
        dataIndex: "total_expense",
        align: "center",
        render: (data) => {
          return this.safeDisplayFloat(data);
        },
      },
      {
        title: "Total Transaction",
        dataIndex: "transaction",
        align: "center",
        render: (data) => {
          return this.safeDisplayFloat(data);
        },
      },
      {
        title: "Total Success",
        dataIndex: "total_success",
        align: "center",
        render: (data) => {
          return this.safeDisplayFloat(data);
        },
      },
      {
        title: "Total Failure",
        dataIndex: "total_failed",
        align: "center",
        render: (data) => {
          return this.safeDisplayFloat(data);
        },
      },
      {
        title: "Total Blackhole",
        dataIndex: "total_blackhole",
        align: "center",
        render: (data) => {
          return this.safeDisplayFloat(data);
        },
      },
    ];

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      hideDefaultSelections: true,
      selections: [
        {
          key: "all-data",
          text: "Select All Data",
          onSelect: () => {
            this.setState({
              selectedRowKeys: [...list.map((i) => i.member_id)],
            });
          },
        },
        {
          key: "odd",
          text: "Select Odd Row",
          onSelect: (changableRowKeys) => {
            let newSelectedRowKeys = [];
            newSelectedRowKeys = changableRowKeys.filter((key, index) => {
              if (index % 2 !== 0) {
                return false;
              }
              return true;
            });
            this.setState({ selectedRowKeys: newSelectedRowKeys });
          },
        },
        {
          key: "even",
          text: "Select Even Row",
          onSelect: (changableRowKeys) => {
            let newSelectedRowKeys = [];
            newSelectedRowKeys = changableRowKeys.filter((key, index) => {
              if (index % 2 !== 0) {
                return true;
              }
              return false;
            });
            this.setState({ selectedRowKeys: newSelectedRowKeys });
          },
        },
      ],
    };

    return (
      <Table
        className="dark-theme-table"
        columns={column}
        dataSource={this.state.data.list}
        rowKey="member_id"
        rowSelection={rowSelection}
        pagination={{
          pageSize: this.state.limit,
          total: this.state.total,
          current: this.state.currentPage,
          onChange: this.onChangePage,
          size: "small",
        }}
      />
    );
  };

  renderSelectedSummary = () => {
    let sms = this.state.data.summary.total_transaction || 0;
    let success =
      this.state.data.summary.total_transaction *
        this.state.data.summary.status_recevied.success || 0;
    let member = this.state.data.summary.total_member;
    let income = this.state.data.summary.total_income;

    if (this.state.selectedRowKeys.length > 0) {
      sms = 0;
      success = 0;
      member = this.state.selectedRowKeys.length;
      income = 0;
      const memberFilter = this.state.data.list.filter((v) =>
        this.state.selectedRowKeys.includes(v.member_id)
      );
      for (const element of memberFilter) {
        sms += element.transaction;
        success += element.total_success;
        income += element.total_expense;
      }
    }

    return {
      sms: sms,
      success: success,
      income: income,
      member: member,
    };
  };

  onChangePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    const { memberId, country, startDate, endDate } = this.props;

    await this.fetchSummary(
      page,
      this.state.limit,
      memberId,
      country,
      startDate,
      endDate
    );
  };

  render() {
    return (
      <Spin spinning={this.state.loading} tip="Loading...">
        <Row className="component monitor-card" gutter={24}>
          <Col span={6}>
            <Card title={"Total SMS"}>
              {this.safeDisplayFloat(this.renderSelectedSummary().sms)}
            </Card>
          </Col>
          <Col span={6}>
            <Card title={"Total Successful"}>
              {this.safeDisplayFloat(this.renderSelectedSummary().success)}
            </Card>
          </Col>
          <Col span={6}>
            <Card title={"Total Income"}>
              <span className="numeric-data">$</span>
              {this.safeDisplayFloat(this.renderSelectedSummary().income)}
            </Card>
          </Col>
          <Col span={6}>
            <Card title={"Total Member"}>
              {this.safeDisplayFloat(this.renderSelectedSummary().member)}
              <span className="numeric-data"> Accounts</span>
            </Card>
          </Col>
        </Row>
        <div className="vertical-stack">
          <Card
            title="Total SMS Transactions Over Time"
            style={{ gridArea: "first" }}
          >
            {this.renderTransactionOverTime()}
          </Card>
          <Card
            title={"Message Destribute By Country"}
            style={{ gridArea: "second" }}
          >
            {this.renderDistributeByCountry()}
          </Card>
          <Card
            title="Success vs Failure vs Blackhole"
            style={{ gridArea: "third" }}
          >
            {this.renderSuccessVsFailVsBlackhole()}
          </Card>
        </div>
        <Row className="component monitor-card" gutter={24}>
          <Col span={24}>
            <Card title="Member List">
              {this.renderSelectedMember()}
              {this.renderMemberTable()}
            </Card>
          </Col>
        </Row>
      </Spin>
    );
  }
}

export default SMPPUsageStatus;



// WEBPACK FOOTER //
// ./src/containers/SmppMonitor/sms.js